<template>
<div>

<div id="genmen" >
  <p class=""> <b>Skapa ett nytt övningsblad genom att välja steg</b></p>
  <div class="inlajn2 genknapp" @click="genereraOvningar(1)">Steg 1</div>
  <div class="inlajn2 genknapp" @click="genereraOvningar(2)">Steg 2</div>
  <div class="inlajn2 genknapp" @click="genereraOvningar(3)">Steg 3</div>
  <div class="inlajn2 genknapp" @click="genereraOvningar(4)">Steg 4</div>
  <br><br>
  <p class="mindre"> Svårighetsgraderna är ungefärliga. Prova gärna både ett steg högre och lägre
  <br>för större utmaning respektive grundläggande repetition.</p>
</div>



<div ref="ytterclass" class="ytterclass">


<!-- här börjar skrivarket -->
    <div v-if="this.uppgifter.length>0" class="ark-container">
      <!--div class="ark-container"-->
  <div id="ark" class="ark">




    <h3>Blandade övningar steg {{ steg }}</h3>










<div class="fuskOrd doljTyska" id="fuskOrd"></div>


<div class="eraser">

<div class="eraser-button"  @click="sudda(uppgifter)"
@mousedown="touchstart()" @mouseup="touchend()"
@touchstart="touchstart()" @touchend="touchend()">
<font-awesome-icon icon="eraser" ></font-awesome-icon>
</div>


</div>



<div id="keyboard" class="keyboardsynlighet">
<div class="inlajn keyboardletter" @click="type('ü')"> ü </div>
<div class="inlajn keyboardletter" @click="type('Ü')"> Ü </div>
<div class="inlajn keyboardletter" @click="type('ß')"> ß </div>
</div>



      <div class="uppgift" v-for="(item, index) in uppgifter" v-bind:key="index">

    <div v-if="dinRattning[index]!='rätt'">

        <div class="fraga">
              {{index +1 }}.
              <div class="fragerad" v-for="(item2, index2) in arraifieraOrd(item[0]) " v-bind:key="index2">
                 <div v-if="(item[2][index2])" class="ord fragerad pekare" :id="'ord' + index2"
                    @mousedown="visaTyska(item[2][index2])"
                    @mouseup="doljTyska()"
                    >
                 {{item2}}
                </div>
                <div v-else class="ord fragerad" :id="'ord' + index2">
                    {{item2}}
                </div>
              </div>
        </div>


        <div>
            <form autocomplete="off">
         <input class="skrivfalt" type="text" :id="'skrivfalt' + index"
           @keydown.13.prevent
           @keydown="sparaKnapptryck(index)"

           @keydown.160="umlautTryckts()"
           @keydown.186="umlautTryckts()"

           @keydown.dead="umlautTryckts()"

           @keydown.116.prevent @keydown.116="skrivDubbelEss(index)"
           @keydown.83.prevent @keydown.83="skrivDubbelEssMedCtrl(index)"

           @keydown.85.prevent @keydown.85="skrivTysktY(index)"

           @click="setFocus(index)"


           spellcheck="false"/>
       </form>
        </div>

        <div class="facitomrade">

          <div class="svar">
            <div class="svar-text" :id="'svar' + index">
              {{ item[1] }}
            </div>
          </div>

          <div class="oga" :id="'oga' + index"
          @mousedown="visaFacit(index)" @mouseup="doljFacit(index)"
          @touchstart="visaFacit(index)" @touchend="doljFacit(index)">
              <i class="fa fa-eye"></i>
          </div>

        </div>


    </div>

      </div>
<div v-if="fullrattad"><h4>Du har klarat alla uppgifter på denna övning.</h4>
    Håll inne suddgummi-ikonen uppe till vänster i 3 sekunder om du vill börja om.<br>
    Eller tryck på någon av knapparna däruppe för att skapa ett nytt övningsblad.
    <br><br></div>

<div class="nav-rad">
    <router-link class="foregaende steg-nav" :to="{path: foregaendeLank }">
                  {{foregaende}}
    </router-link>

    <div class="pekare" id="tillRattning" @click="tillRattning()">Rättning</div>

    <router-link class="nasta steg-nav" :to="{path: nastaLank }">
                  {{nasta}}
    </router-link>

</div>



  </div>



</div>

<!-- här slutar skrivarket -->




<!-- här börjar facit....................................................................... -->
    <div class="ark-container-facit">
  <div id="facit-ark" class="ark-facit osynlig">
    <h3>Blandade övningar steg {{ steg }}</h3>
    <h4 class="rod">Rättning</h4>

      <div class="uppgift facit-uppgift" v-for="(item, index) in uppgifter" v-bind:key="index">

        <div class="fraga gra-text">
                          {{index +1 }}. {{ item[0] }}
        </div>

          <!-- här skrivs sen användarens svar med fyllFacit()..Detta skapar bara id:ar............................. -->
        <div>

           <div class="skrivfalt-facit smalare-border" :id="'facitfalt' + index">

           </div>

        </div>




        <div class="facitomrade">

          <div class="svar">
            <div class="facit-text" :id="'svar' + index">
              {{ item[1] }}
            </div>
          </div>



          <div :id="'kommentarsfalt'+index"> <!-- försök att loopa i loop i kommentars array-->
                <div class="kommentarer" v-for="(item2, index2) in rattningskommentarer[index]" v-bind:key="index2">
                    <br>&#9888; {{item2}}

                </div>
        </div>


          <div class="rattningsknappar">

          <div class="rodknapp knapp pekare" :id="'rodknapp' + index" @click="rodtryckt(index)">
              FEL
          </div>

          <div class="gronknapp knapp pekare" :id="'gronknapp' + index" @click="grontryckt(index)">
              RÄTT
          </div>

      </div>

        </div>

      </div>

<div class="nav-rad">
<div id="allaRätt" v-if="arAlltRatt()" class="vit-puls"> Du har alla rätt !!!</div>
<div id="tranaIgen" class="pekare" @click="tranaIgen()">Träna igen på det som blev fel</div>

</div>
  </div>
</div>

<!-- här slutar facit.................................................................................. -->





</div>

</div>
</template>

<script>





export default {
  name: 'Blandadeovningar',
  title () {
    return `Blandade övningar steg `+this.steg + ` | Tysk Grammatik`
  },
  components: {

},
  props: {
    title: String,

    grammatik: String,
    avsnitt: String,
    grambok: Boolean,
    foregaende:String,
    nasta:String,
    foregaendeLank:String,
    nastaLank:String
},


data() {
    //var that=this;
    //var umlaut = false;

        return {
            dinRattning: window.document.done['BlandadeOvningar']['dinRattning'] || "",
            hover: false,
            fullrattad: false,

            steg: window.document.done['GenereradeMeningar']['dinRattning'][0],
            timer:Function,
            touchduration: 3000,
            rattningskommentarer:[],
            umlaut: false, //kolla om detta
            cursorX: Number,
            cursorY:Number,
            uppgifter: window.document.done['GenereradeMeningar']['dittSvar'],
            uppgiftsbas: [
              [//steg 1 das
                ["Vad heter du?", "Wie heißt du?",[]],
                ["Jag är 14 år gammal.", "Ich bin 14 Jahre alt.",["","","","das Jahr -e","alt"]],
                ["Jag heter Lars.", "Ich heiße Lars.",[]],
                ["Jag kommer från Sverige.", "Ich komme aus Schweden.",["","","aus","Schweden"]],
                ["Hon kommer från Schweiz.", "Sie kommt aus der Schweiz.",[]],
                ["Schweiz är vackert.", "Die Schweiz ist schön.",["die Schweiz"]],
                ["Jag bor i Lund.", "Ich wohne in Lund.",[]],
                ["Mina föräldrar kommer från Mölndal.", "Meine Eltern kommen aus Mölndal.",[]],
                ["Jag har en bror och två systrar.", "Ich habe einen Bruder und zwei Schwestern.",["","","","der Bruder -+","","","die Schwester -n"]],
                ["Min mamma arbetar.", "Meine Mutter arbeitet.",["","die Mutter -+"]],
                ["Min pappa är lärare.", "Mein Vater ist Lehrer.",["","der Vater -+","","der Lehrer -"]],
                ["Jag går i skolan.", "Ich gehe in die Schule.",["","in die Schule gehen","in die Schule gehen","in die Schule gehen"]],
                ["Jag läser tyska.", "Ich lerne Deutsch.",["","lerne",""]],
                ["Jag läser en bok.", "Ich lese ein Buch.",["","lesen",""]],
                ["Hon läser en bok.", "Sie liest ein Buch.",["","lesen",""]],
                ["Jag pratar lite tyska, men inte så bra.", "Ich spreche ein bisschen Deutsch, aber nicht so gut.",["","","ein bisschen"]],
                ["Jag förstår dig.", "Ich verstehe dich.",[]],
                ["Ses imorgon!", "Bis morgen!",[]],
                ["Kan du upprepa det där tack?", "Kannst du das bitte wiederholen?",["","","wiederholen","","bitte"]],
                ["Snälla prata långsamt.", "Bitte sprich langsam.",[]],
                ["Har du en bok?", "Hast du ein Buch?",[]],
                ["Boken är intressant.", "Das Buch ist interessant.",[]],
                ["Gatan är väldigt lång.", "Die Straße ist sehr lang.",[]],
                ["Jag skriver en text.", "Ich schreibe einen Text.",["","","","der Text -e"]],
                ["Träden är gröna.", "Die Bäume sind grün.",["der Baum -+e"]],
                ["Jag dricker en cola.", "Ich trinke eine Cola.",["","","die Cola -s"]],
                ["Är du hungrig?", "Hast du Hunger?",[]],
                ["Vi går hem.", "Wir gehen nach Hause.",[]],
                ["Är ni hemma barn?", "Seid ihr zu Hause, Kinder?",[]],
                ["Vi kommer imorgon.", "Wir kommen morgen.",[]],
                ["Idag är det onsdag.", "Heute ist Mittwoch.",[]],
                ["Imorgon är det fredag.", "Morgen ist Freitag.",[]],
                ["Det är kallt.", "Es ist kalt.",[]],
                ["Har du en katt?", "Hast du eine Katze.",[]],
                ["Jag har en hund.", "Ich habe einen Hund.",["","","","der Hund -"]],
                ["Min bror heter Isak.", "Mein Bruder heißt Isak.",[]],
                ["Jag lyssnar på musik.", "Ich höre Musik.",["","höre","höre"]],
                ["Vi tittar på tv.", "Wir sehen fern.",[]],
                ["Du sover.", "Du schläfst.",[]],
                ["Arbetar ni här?", "Arbeitet ihr hier?",[]],
                ["Trädet är grönt.", "Der Baum ist grün.",[]],
                ["Huset är litet.", "Das Haus ist klein.",[]],
                ["Han är lycklig.", "Er ist glücklich.",[]],
                ["Vi är ledsna.", "Wir sind traurig.",[]],
                ["Klockan fyra åker vi hem.", "Um vier Uhr fahren wir nach Hause.",[]],
                ["Klockan är kvart i åtta.", "Es ist viertel vor acht.",[]],
                ["Hur mycket är klockan?", "Wie viel Uhr ist es?",[]],
                ["Var är du?", "Wo bist du?",[]],
                ["Var är ni?", "Wo seid ihr?",[]],
                ["Är ni läkare, herr Bauchmann?", "Sind Sie Arzt, Herr Bauchmann?",["","","der Arzt -+e"]],
                ["Min fru är läkare.", "Meine Frau ist Ärztin.",["","die Frau -en","","die Ärztin -nen"]],
                ["Mina barn är glada.", "Meine Kinder sind froh.",["","das Kind -er"]],
                ["Min syster är också lärarinna.", "Meine Schwester ist auch Lehrerin.",["", "die Schwester -n","","","die Lehrerin -nen"]],
                ["Har ni en fotboll?", "Habt ihr einen Fußball?",[]],
                ["Hans cykel är trasig.", "Sein Fahrrad ist kaputt.",["","das Fahrrad -+er","","kaputt"]],
                ["Hennes pojkvän är snäll.", "Ihr Freund ist lieb.",[]],
                ["Kan du komma imorgon?", "Kannst du morgen kommen?",[]],
                ["Vill du köpa bröd?", "Willst du Brot kaufen?",[]],
                ["Vi vill vara här.", "Wir wollen hier sein.",[]],
                ["Det vet jag inte.", "Das weiß ich nicht.",[]],
                ["Vi vet, var du bor.", "Wir wissen, wo du wohnst.",[]],
                ["Skulle Ni vilja ha en kaffe?", "Möchten Sie einen Kaffee haben?",["","","","","","der Kaffee"]],
                ["Bröderna arbetar mycket.", "Die Brüder arbeiten viel.",[]],
                ["Vart går du?", "Wohin gehst du?",[]],
                ["Han åker till Stockholm.", "Er fährt nach Stockholm.",[]],

              ],
              [//steg2 band
                ["Jag stiger upp varje morgon klockan sju.", "Ich stehe jeden Morgen um sieben Uhr auf.",[]],
                ["Jag går till skolan klocka åtta.", "Ich gehe um acht Uhr zur Schule.",[]],
                ["Varför kommer du inte?", "Warum kommst du nicht?",[]],
                ["Min bästa vän heter Lukas.", "Mein bester Freund heißt Lukas.",[]],
                ["Vi lär oss tyska tillsammans.", "Wir lernen zusammen Deutsch.",[]],
                ["På eftermiddagen gör jag mina läxor.", "Am Nachmittag mache ich meine Hausaufgaben.",["","","","","","die Hausaufgabe -n"]],
                ["Senare spelar jag datorspel.", "Später spiele ich Computerspiele.",["","","","das Computerspiel -e"]],
                ["På kvällen tittar jag ofta på tv.", "Am Abend sehe ich oft fern.",["am Abend","am Abend","fernsehen","","","fernsehen","fernsehen"]],
                ["Jag går och lägger mig klockan tio.", "Ich gehe um zehn Uhr ins Bett.",[]],
                ["Vad gör du på helgen?", "Was machst du am Wochenende?",["","","","am Wochenende","am Wochenende"]],
                ["På lördag träffar jag mina vänner.", "Am Samstag treffe ich meine Freunde.",[]],
                ["Vi går på bio eller på kafé.", "Wir gehen ins Kino oder ins Café.",[]],
                ["På lördag hälsar jag på mina farföräldrar.", "Am Sonntag besuche ich meine Großeltern.",[]],
                ["Min mormor lagar väldigt bra mat.", "Meine Oma kocht sehr gut.",["","die Oma -s","kochen"]],
                ["Jag hjälper henne ibland.", "Ich helfe ihr manchmal.",[]],
                ["Jag ger honom en present.", "Ich gebe ihm ein Geschenk.",["","","","","das Geschenk -e"]],
                ["Min bror spelar gärna fotboll.", "Mein Bruder spielt gern Fußball.",[]],
                ["Jag spelar hellre basket.", "Ich spiele lieber Basketball.",[]],
                ["Vi har ofta idrott i skolan.", "Wir haben oft Sport in der Schule.",[]],
                ["Vår lärare är trevlig och vänlig.", "Unser Lehrer ist nett und freundlich.",["", "der Lehrer -","","nett","","freundlich"]],
                ["Våra lärare är trevliga och vänliga.", "Unsere Lehrer sind nett und freundlich.",["", "der Lehrer -","","nett","","freundlich"]],
                ["Jag har inga läxor idag.", "Ich habe heute keine Hausaufgaben.",["","","","die Hausaufgabe -n","heute"]],
                ["Har du tid att träffa mig?", "Hast du Zeit, mich zu treffen?",[]],
                ["Jag kan inte komma idag.", "Ich kann heute nicht kommen.",[]],
                ["Varför är du ledsen?", "Warum bist du traurig?",[]],
                ["Jag är trött eftersom jag har sovit lite.", "Ich bin müde, weil ich wenig geschlafen habe.",[]],
                ["Jag såg en film igår. (använd perfekt)", "Ich habe gestern einen Film gesehen.",[]],
                ["Därför har jag ingen bil.", "Deshalb habe ich kein Auto.",["deshalb","","","","das Auto -s"]],
                ["Filmen var väldigt spännande.", "Der Film war sehr spannend.",[]],
                ["Jag läser gärna böcker på tyska.", "Ich lese gern Bücher auf Deutsch.",[]],
                ["Jag förstår redan många ord.", "Ich verstehe schon viele Wörter.",[]],
                ["Tyska är ibland svårt, men intressant.", "Deutsch ist manchmal schwierig, aber interessant.",["","","manchmal","schwierig","","interessant"]],
                ["Jag åker till tyskland i sommar.", "Ich fahre im Sommer nach Deutschland.",[]],
                ["Där besöker jag några vänner.", "Dort besuche ich einige Freunde.",["dort","","","einige","der Freund -e"]],
                ["Jag skulle vilja prata bättre tyska.", "Ich möchte besser Deutsch sprechen.",[]],
                ["Jag lär mig nya ord varje dag.", "Ich lerne jeden Tag neue Wörter.",["","lernen","lernen","","das Wort -+er","jeden","Tag"]],
                ["Mitt favoritämne är engelska.", "Mein Lieblingsfach ist Englisch.",[]],
                ["Jag gillar inte franska.", "Ich mag nicht Französisch.",["","","","Französisch"]],
                ["Matte tycker jag inte är så lätt.", "Mathe finde ich nicht so leicht.",["Mathe","finden","","","","","leicht"]],
                ["Jag har ett test imorgon.", "Ich habe morgen einen Test.",["", "","","der Test -s","morgen"]],
                ["Jag måste plugga mycket idag.", "Ich muss heute viel lernen.",[]],
                ["Mina föräldrar hjälper mig ofta.", "Meine Eltern helfen mir oft.",[]],
                ["Jag frågar läraren, när jag inte förstår något.", "Ich frage den Lehrer, wenn ich etwas nicht verstehe.",["","fragen","der Lehrer","","",""]],
                ["Det är mycket kallt ute idag.", "Es ist heute sehr kalt draußen.",["","","","kalt","draußen","heute"]],
                ["Jag tar på mig en varm jacka.", "Ich ziehe eine warme Jacke an.",["","anziehen","anziehen","anziehen", "","warm","die Jacke -n"]],
                ["På vintern åker jag gärna skidor.", "Im Winter fahre ich gern Ski.",["im Winter","im Winter","","","","Ski"]],
                ["På sommaren simmar jag i sjön.", "Im Sommer schwimme ich im See.",["im Sommer","im Sommer","schwimmen","","im See","im See"]],
                ["Jag lyssnar gärna på musik från Tyskland.", "Ich höre gern Musik aus Deutschland.",[]],
                ["Min favoritlåt är vädligt vacker.", "Mein Lieblingslied ist sehr schön.",[]],
                ["Mitt tyska favoritband heter Geschmeido.", "Meine deutsche Lieblingsband heißt Geschmeido.",["","","die Lieblingsband -s"]],
                ["Vi pratar om skolan och fritiden.", "Wir sprechen über Schule und Freizeit.",["","","über","Schule","","Freizeit"]],
                ["Då har jag mycket tid att koppla av.", "Dann habe ich viel Zeit zum Entspannen.",["","","","","","zum Entspannen","zum Entspannen","zum Entspannen"]],
              ],
              [//steg3 schon
                ["Jag går till skolan varje dag.", "Ich gehe jeden Tag zur Schule.",["", "", "zur Schule", "zur Schule", "", "der Tag -e"]],
                ["På helgerna spelar jag fotboll med mina vänner", "Am Wochenende spiele ich Fußball mit meinen Freunden.",[]],
                ["Jag äter frukost med min familj.", "Ich frühstücke mit meiner Familie.",["","frühstücken","frühstücken","","","die Familie -n"]],
                ["Min syster läser gärna böcker.", "Meine Schwester liest gern Bücher.",["","die Schester -n","","","das Buch -+er"]],
                ["Vi har sett en film igår.", "Wir haben gestern einen Film gesehen.",["", "", "", "" ,"der Film -e"]],
                ["Kan du hjälpa mig är du snäll?", "Kannst du mir bitte helfen?",["","","","bitte","bitte","bitte"]],
                ["Väskan står på bordet.", "Die Tasche steht auf dem Tisch.",["die Tasche -n","","","der Tisch -e","",""]],
                ["Jag läser tyska sen två år.", "Ich lerne seit zwei Jahren Deutsch.",["", "lernen"]],
                ["Imorgon åker jag till Berlin.", "Morgen fahre ich nach Berlin.",[]],
                ["Han arbetar på ett kontor.", "Er arbeitet in einem Büro.",["","","","","das Büro -s"]],
                ["Efter skolan går jag hem.", "Nach der Schule gehe ich nach Hause.",[]],
                ["Hon lagar pasta ikväll.", "Sie kocht heute Abend Nudeln.",["","kochen","Nudeln"]],
                ["Jag har redan gjort mina läxor.", "Ich habe schon meine Hausaufgaben gemacht.",["","","schon","","","die Hausaufgabe -n"]],
                ["Varför kom du så sent? (använd perfekt)", "Warum bist du so spät gekommen?",[]],
                ["Vi träffas klockan åtta.", "Wir treffen uns um acht Uhr.",[]],
                ["Sätt dig bakom trädet!", "Setz dich hinter den Baum!",[]],
                ["Jag skulle vilja bli läkare sen.", "Ich möchte später Arzt werden.",[]],
                ["Han har inte förstått boken.", "Er hat das Buch nicht verstanden.",[]],
                ["Hon pratar väldigt bra engelska.", "Sie spricht sehr gut Englisch.",[]],
                ["Jag dricker alltid kaffe på morgonen.", "Ich trinke morgens immer Kaffee.",["","","","Kaffee"]],
                ["Har du sett filmen?", "Hast du den Film gesehen?",["","","","der Film -e"]],
                ["Vi bor i en liten stad.", "Wir wohnen in einer kleinen Stadt.",["","","","","","die Stadt -+e"]],
                ["Min bror är äldre än jag.", "Mein Bruder ist älter als ich.",[]],
                ["Idag är det väldigt vackert väder.", "Heute ist das Wetter sehr schön.",["","","","","","das Wetter"]],
                ["Jag prommenerar gärna", "Ich gehe gern spazieren.",["","spazieren gehen"]],
                ["Hon arbetade länge igår. (använd perfekt)", "Sie hat gestern lange gearbeitet.",["","","lange"]],
                ["Vi gör ofta utflykter tillsammans", "Wir machen oft Ausflüge zusammen.",["","","oft","der Ausflug -+e","zusammen"]],
                ["Jag har inte tid idag.", "Ich habe heute keine Zeit.",[]],
                ["Kan jag sitta här?", "Kann ich hier sitzen?",[]],
                ["Han spelar bra gitarr.", "Er spielt gut Gitarre.",["","","","die Gitarre -n"]],
                ["Jag handlar på snabbköpet.", "Ich kaufe im Supermarkt ein.",["","einkaufen","","der Supermarkt -+e"]],
                ["Hon pluggar inför provet.", "Sie lernt für die Prüfung.",["","lernen","","die Prüfung -en"]],
                ["Vi åker till havet på sommaren.", "Wir fahren im Sommer ans Meer.",["","","","das Meer"]],
                ["Jag har tappat min nyckel.", "Ich habe meinen Schlüssel verloren.",["","","verloren (i perfekt)","","der Schlüssel -"]],
                ["Han kommer från Polen", "Er kommt aus Polen.",["","","","Polen"]],
                ["Jag förstår inte uppgiften.", "Ich verstehe die Aufgabe nicht.",["","","","die Aufgabe -n"]],
                ["Vi har haft väldigt kul.", "Wir haben viel Spaß gehabt.",[]],
                ["Hon har på sig en röd klänning.", "Sie trägt ein rotes Kleid.",["", "tragen", "tragen", "tragen","","","das Kleid -er"]],
                ["Jag äter gärna pizza.", "Ich esse gern Pizza.",[]],
                ["När börjar undervisningen?", "Wann beginnt der Unterricht?",["","beginnen","der Unterricht"]],
                ["Han har skickat ett mejl till mig.", "Er hat mir eine E-Mail geschickt.",["","","","","die E-Mail -s"]],
                ["Jag är trött, men lycklig", "Ich bin müde, aber glücklich.",["","","müde","","glücklich"]],
                ["Jag vet inte när undervisningen börjar.", "Ich weiß nicht, wann der Unterricht beginnt.",["","","","","der Unterricht","beginnen"]],
                ["Vi besöker våra morföräldrar.", "Wir besuchen unsere Großeltern.",[]],
                ["Hon har köpt en ny mobil.", "Sie hat ein neues Handy gekauft.",["","","","","","das Handy -s"]],
                ["Jag stiger upp tidigt varje morgon.", "Ich stehe jeden Morgen früh auf.",["","aufstehen","aufstehen"]],
                ["Han springer väldigt snabbt.", "Er läuft sehr schnell.",["","laufen"]],
                ["Vi har stannat hemma idag.", "Wir sind heute zu Hause geblieben.",[]],
                ["Jag gjorde inget igår. (använd perfekt)", "Ich habe gestern nichts gemacht.",["","","nichts"]],
                ["Hon dansade länge (använd perfekt)", "Sie hat lange getanzt.",[]],
                ["Jag lyssna ofta på musik.", "Ich höre oft Musik.",[]],
                ["Vi pluggar tillsammans inför tentan.", "Wir lernen zusammen für die Klausur.",["","lernen","","","die Klausur -en"]],
                ["Han har städat på sitt rum.", "Er hat sein Zimmer aufgeräumt.",["","","aufräumen","","das Zimmer -"]],
                ["Jag går på bio ikväll. Vill du följa med?", "Ich gehe heute Abend ins Kino. Willst du mitkommen?",["","","","","","","","mitkommen","mitkommen"]],
                ["Hon har ingen lust att komma hem.", "Sie hat keine Lust nach Hause zu kommen.",[]],
                ["Jag behöver hjälp med läxorna.", "Ich brauche Hilfe bei den Hausaufgaben.",["","brauchen", "Hilfe", "bei","die Hausaufgabe -n"]],
                ["Vi pratar om problemet.", "Wir sprechen über das Problem.",["","","","das Problem -e"]],
                ["Han förstår inte reglerna.", "Er versteht die Regeln nicht.",["","","","die Regel -n"]],
                ["Jag är hungrig.", "Ich habe Hunger.",[]],
                ["Hon går och handlar.", "Sie geht einkaufen.",[]],
                ["Han har gått hem.", "Er ist nach Hause gegangen.",[]],
                ["Han har stannat hemma.", "Er ist zu Hause geblieben.",[]],
                ["Jag sov länge igår. (använd perfekt)", "Ich habe gestern lange geschlafen.",[]],
                ["Han åker buss.", "Er fährt mit dem Bus.",["","","der Bus -se"]],
                ["Jag har precis läst en intressant bok.", "Ich habe gerade ein interessantes Buch gelesen.",[]],
                ["Hon jobbar på sjukhuset.", "Sie arbeitet im Krankenhaus.",["","","","das Krankenhaus -+er"]],
                ["Jag tycker att tyska är intressant.", "Ich finde Deutsch interessant.",[]],
                ["Han är väldigt trevlig.", "Er ist sehr nett.",["","","","freundlich"]],
                ["Jag skriver ett meddelande", "Ich schreibe eine Nachricht.",["", "","" ,"die Nachricht -en"]],
                ["Vi går och simmar idag.", "Wir gehen heute schwimmen.",["","schwimmen gehen","schwimmen gehen","schwimmen gehen"]],
                ["Jag har glömt min väska", "Ich habe meine Tasche vergessen.",["","","vergessen","","die Tasche -n"]],
                ["Han hjälper sin mamma.", "Er hilft seiner Mutter.",["","helfen (styr dativ)","","die Mutter -+"]],
                ["Jag lär mig nya ord.", "Ich lerne neue Wörter.",["","","","","das Wort -+er"]],
                ["Hon tittar på tv.", "Sie sieht fern.",["","fernsehen","fernsehen", "fernsehen"]],
                ["Vi har träffat nya människor.", "Wir haben neue Leute getroffen.",[]],
                ["Jag går och lägger mig.", "Ich gehe ins Bett.",["","ins Bett gehen","ins Bett gehen","ins Bett gehen","ins Bett gehen"]],
                ["Har du spelat fotboll igår?", "Hast du gestern Fußball gespielt?",[]],
                ["Jag är sjuk idag.", "Ich bin heute krank.",["","","","krank"]],
                ["Hon läser alltid tidningen på morgonen.", "Sie liest immer morgens die Zeitung.",["","","","dieZeitung -en"]],
                ["Vi gör våra läxor.", "Wir machen unsere Hausaufgaben.",["","","","die Hausaufgabe -en"]],
                ["De gör sina läxor.", "Sie machen ihre Hausaufgaben.",["","","","die Hausaufgabe -en"]],
                ["Hon gör sina läxor.", "Sie macht ihre Hausaufgaben.",["","","","die Hausaufgabe -en"]],
                ["Han gör sina läxor.", "Er macht seine Hausaufgaben.",["","","","die Hausaufgabe -en"]],
                ["Jag har ingen aning.", "Ich habe keine Ahnung.",["","","","die Ahnung -en"]],
                ["Man måste göra sina läxor.", "Man muss seine Hausaufgaben machen.",["","","","","die Hausaufgabe -n"]],
                ["Han köper en present åt henne.", "Er kauft ihr ein Geschenk.",["","","","das Geschenk -e"]],
                ["Jag utövar idrott.", "Ich treibe Sport.",["","treiben","Sport"]],
                ["Vi åker nattåget till Österrike på vintern.", "Wir fahren im Winter mit dem Nachtzug nach Österreich.",["","","der Nachtzug -+e"]],
                ["Jag går gärna på restaurang.", "Ich gehe gern ins Restaurant.",["","","","","das Restaurant -s"]],
                ["Han har tappat sin mobil.", "Er hat sein Handy verloren.",["","","","","das Handy -s"]],
                ["Jag behöver en paus.", "Ich brauche eine Pause.",["","","","die Pause -n"]],
                ["Vi ses imorgon.", "Wir sehen uns morgen.",[]],
                ["Jag jobbade mycket igår. (använd perfekt)", "Ich habe gestern viel gearbeitet.",[]],
                ["Dieter bor i en stor stad.", "Dieter wohnt in einer großen Stadt.",[]],
                ["Jag tycker det är svårt.", "Ich finde es schwer.",["","","","","schwer"]],
                ["Vi behöver mer tid.", "Wir brauchen mehr Zeit.",[]],
                ["Vi tar en prommenad idag.", "Wir gehen heute spazieren.",[]],
                ["Jag kommer från Sverige, men mina farföräldrar kommer från Danmark.", "Ich komme aus Schweden, aber meine Großeltern kommen aus Dänemark.",[]],
                ["Han lär sig väldigt snabbt.", "Er lernt sehr schnell.",[]],
                ["Jag har aldrig förstått dig.", "Ich habe dich noch nie verstanden.",["", "","noch nie"]],
                ["Hon hjälper mig ofta", "Sie hilft mir oft.",["", "helfen (styr dativ)","","oft"]],
                ["Är den här platsen ledig?", "Ist hier noch frei?",[]],
                ["Får man dricka alkohol i Sverige?", "Darf man in Schweden Alkohol trinken?",[]],

              ],
              [//steg4 gegessen
                ["Jag tror att han inte har tid idag.", "Ich glaube, dass er heute keine Zeit hat.",[]],
                ["Om jag hade haft mer pengar skulle jag resa.", "Wenn ich mehr Geld hätte, würde ich reisen.",[]],
                ["Fastän det har regnat har vi gått en prommenad.", "Obwohl es geregnet hat, sind wir spazieren gegangen.",[]],
                ["Han sa att han kan komma imorgon.", "Er sagte, dass er morgen kommen würde.",[]],
                ["Jag gläder mig över att återse dig.", "Ich freue mich darauf, dich wiederzusehen.",[]],
                ["Efter att jag har ätit gör jag mina läxor.", "Nachdem ich gegessen habe, mache ich meine Hausaufgaben.",[]],
                ["Hon intresserar sich för modern konst.", "Sie interessiert sich für moderne Kunst.",["","sich interessieren","sich interessieren","","","die Kunst"]],
                ["Vi har beslutat att gå tidigare.", "Wir haben beschlossen, früher zu gehen.",["","","",""]],
                ["Det är viktigt att plugga regelbundet.", "Es ist wichtig, regelmäßig zu lernen.",["","","","","lernen","regelmäßig"]],
                ["Jag har glömt att avboka tiden.", "Ich habe vergessen, den Termin abzusagen.",["","","","","absagen","der Termin"]],
                ["Om du vill kan vi träffas senare.", "Wenn du willst, können wir uns später treffen.",[]],
                ["Han har förklarat för mig hur man löser problemet.", "Er hat mir erklärt, wie man das Problem löst.",["","","erklären (styr dativ)","","","","das Problem"]],
                ["Jag är inte säker på om det stämmer.", "Ich bin mir nicht sicher, ob es stimmt.",["","","","sich (dat) sicher sein","sich (dat) sicher sein"]],
                ["Hon arbetar för att tjäna pengar.", "Sie arbeitet, um Geld zu verdienen.",["","","","","verdienen","das Geld"]],
                ["Jag har ingen lust att gå ut idag.", "Ich habe keine Lust, heute auszugehen.",["","","","die Lust","","auszugehen","auszugehen"]],
                ["Fastän han var trött arbetade han vidare. (använd perfekt)", "Obwohl er müde war, hat er weitergearbeitet.",["obwohl","","","müde","weiterarbeiten","","weiterarbeiten"]],
                ["Jag kommer ihåg att vi var där.", "Ich erinnere mich daran, dass wir dort waren.",["","sich erinnern","sich erinnern"]],
                ["Det vore bättre, om du kommer tidigare.", "Es wäre besser, wenn du früher kommst.",[]],
                ["Han uppför sig som om han visste allt.", "Er tut so, als ob er alles wüsste.",["","so tun","so tun","als ob","als ob","","wüsste"]],
                ["Jag hoppas att allt går bra.", "Ich hoffe, dass alles gut läuft.",["","","","","laufen"]],
                ["Medan jag pluggade lyssnade jag på musik, fastän det är dumt.", "Während ich lernte, hörte ich Musik, obwohl es blöd ist.",[]],
                ["Hon har börjat att prata tyska.", "Sie hat angefangen, Deutsch zu sprechen.",["","","anfangen"]],
                ["Jag vet inte varför han har gjort det.", "Ich weiß nicht, warum er das gemacht hat.",[]],
                ["När jag har tid läser jag en bok.", "Wenn ich Zeit habe, lese ich ein Buch.",[]],
                ["Han har lovat att hjälpa mig.", "Er hat versprochen, mir zu helfen.",[]],
                ["Jag är van vid att stiga upp tidigt.", "Ich bin daran gewöhnt, früh aufzustehen.",[]],
                ["Det verkar som att han är sjuk.", "Es scheint, als ob er krank ist.",["","scheinen als","scheinen als"]],
                ["Vi har pratat om vart vi skall resa.", "Wir haben darüber gesprochen, wohin wir reisen wollen.",["","","","","","","(här) wollen"]],
                ["Jag ämnar studera nästa år.", "Ich habe vor, nächstes Jahr zu studieren.",["","vorhaben"]],
                ["Hon har bett mig att hjälpa henne.", "Sie hat mich gebeten, ihr zu helfen.",[]],
                ["Jag tycker att det är svårt att lösa den här uppgiften.", "Ich finde es schwierig, diese Aufgabe zu lösen.",[]],
                ["Han har slutat att röka.", "Er hat aufgehört zu rauchen.",[]],
                ["Jag skulle gärna vilja veta vad du tänker.", "Ich würde gern wissen, was du denkst.",[]],
                ["Fastän hon hade lite tid klarade hon allt. (använd perfekt)", "Obwohl sie wenig Zeit hatte, hat sie alles geschafft.",[]],
                ["Vi planerar, att åka till Italien i sommar.", "Wir planen, im Sommer nach Italien zu fahren.",[]],
                ["Det är inte lätt att lära sig ett nytt språk.", "Es ist nicht leicht, eine neue Sprache zu lernen.",[]],
                ["Jag har hört att han har flyttat.", "Ich habe gehört, dass er umgezogen ist.",["","","","","","","umziehen, zug um, ist umgezogen"]],
                ["Om jag vore du, skulle jag inte göra det.", "Wenn ich du wäre, würde ich das nicht tun.",[]],
                ["Han har glömt att ta med sig sin nyckel.", "Er hat vergessen, seinen Schlüssel mitzunehmen.",[]],
                ["Vi är stolta över att ha fixat det.", "Wir sind stolz darauf, es geschafft zu haben.",[]],
                ["Hon är rädd för att göra fel.", "Sie hat Angst, einen Fehler zu machen.",["","","","","","","einen Fehler machen"]],
                ["Jag försöker att prata tyska varje dag.", "Ich versuche jeden Tag Deutsch zu sprechen.",[]],
                ["Det är möjligt att han kommer senare.", "Es ist möglich, dass er später kommt.",[]],
                ["Vi har lärt oss hur man skriver bättre.", "Wir haben gelernt, wie man besser schreibt.",[]],
                ["Jag har bestämt mig att utöva mer sport.", "Ich habe beschlossen, mehr Sport zu treiben.",["","","beschließen, beschloss, hat beschlossen","","","treiben"]],
                ["Han har hjälpt mig att förstå uppgiften.", "Er hat mir geholfen, die Aufgabe zu verstehen.",[]],
                ["Jag är glad att du har kommit.", "Ich freue mich, dass du gekommen bist.",[]],
                ["Fastän jag var sjuk, gick jag till skolan.", "Obwohl ich krank war, bin ich zur Schule gegangen.",[]],
                ["Jag tänker ofta efter vad jag skall göra.", "Ich denke oft darüber nach, was ich tun soll.",[]],
                ["Hon har glömt att svara mig.", "Sie hat vergessen, mir zu antworten.",[]],
                ["Det är svårt att förstå allt.", "Es ist schwer, alles zu verstehen.",["","","schwer"]],
                ["Jag har inte haft tid att ringa dig.", "Ich habe keine Zeit gehabt, dich anzurufen.",[]],
                ["Han har sagt till mig att han är mycket upptagen.", "Er hat mir gesagt, dass er sehr beschäftigt ist.",["","","","","","","","","","beschäftigt"]],
                ["Jag har försökt att lösa problemet.", "Ich habe versucht, das Problem zu lösen.",[]],
                ["Hon har börjat arbeta.", "Sie hat angefangen zu arbeiten.",[]],
                ["Jag hoppas på att se dig snart.", "Ich hoffe, dich bald zu sehen.",[]],
                ["Vi har skrattat åt det.", "Wir haben darüber gelacht.",[]],
                ["Jag har ingen lust att plugga idag.", "Ich habe keine Lust, heute zu lernen.",[]],
                ["Det där är det största trädet som jag någonsin har sett.", "Das ist der größte Baum, den ich je gesehen habe.",["","","","","der Baum -+e","","","je"]],
                ["Han har frågat mig om jag kan komma.", "Er hat mich gefragt, ob ich kommen kann.",[]],
                ["Fastän det var kallt, har vi stannat ute.", "Obwohl es kalt war, sind wir draußen geblieben.",["","","","","","","","draußen"]],
                ["Jag har glömt var jag har lagt boken.", "Ich habe vergessen, wo ich das Buch hingelegt habe.",["","","","","","","hinlegen"]],
                ["Det är viktigt att du är punktlig.", "Es ist wichtig, dass du pünktlich bist.",["","","","","","","pünktlich"]],
                ["Jag är rädd att jag kommer för sent.", "Ich habe Angst, dass ich zu spät komme.",[]],
                ["Han har försökt att nå mig.", "Er hat versucht, mich zu erreichen.",["","","","","errichen"]],
                ["Jag har lärt mig att prata bättre.", "Ich habe gelernt, besser zu sprechen.",[]],
                ["Hon har bjudit mig att hälsa på henne.", "Sie hat mich eingeladen, sie zu besuchen.",["","","einladen"]],
                ["Jag vet att det är svårt.", "Ich weiß, dass es schwierig ist.",["","","","","","schwierig"]],
                ["Det hade varit kul att se dig.", "Es wäre schön, dich zu sehen.",[]],
                ["Jag har ingen aning om vad som har hänt.", "Ich habe keine Ahnung, was passiert ist.",[]],
                ["Han har börjat att läsa mer.", "Er hat angefangen, mehr zu lesen.",[]],
                ["Jag tänker gå och lägga mig tidigt idag. ", "Ich habe vor, heute früh schlafen zu gehen.",["","vorhaben","schlafengehen","schlafengehen","schlafengehen","schlafengehen"]],
                ["Hon har bett mig att vara lugn.", "Sie hat mich gebeten, ruhig zu sein.",[]],
                ["Jag tycker det är viktigt att leva hälsosamt.", "Ich finde es wichtig, gesund zu leben.",["","","","","","","","","gesund"]],
                ["Han har glömt att stänga av datorn.", "Er hat vergessen, den Computer auszuschalten.",["","","","","ausschalten","der Computer -s"]],
                ["Det är möjligt att vi misstar oss.", "Es ist möglich, dass wir uns irren.",["","","","","","sich irren","sich irren"]],
                ["Jag känner mannen som du jobbar med.", "Ich kenne den Mann, mit dem du arbeitest.",[]],
                ["Han har bestämt sig att gå hem.", "Er hat beschlossen, nach Hause zu gehen.",["","","beschließen, beschloss, hat beschlossen","beschließen, beschloss, hat beschlossen",]],
                ["Fastän jag hade pluggat mycket var provet inte lätt.", "Obwohl ich viel gelernt hatte, war die Prüfung nicht einfach.",["","","","lernen","","","die Prüfung -en"]],
                ["Jag har inte haft tid att läsa allt.", "Ich habe keine Zeit gehabt, alles zu lesen.",[]],
                ["Han har hjälpt mig att förbättra mig.", "Er hat mir geholfen, mich zu verbessern.",[]],
                ["Jag har lärt mig att ha tålamod.", "Ich habe gelernt, geduldig zu sein.",["","","","","","geduldig sein","geduldig sein"]],
                ["Det är viktigt att vi sammarbetar.", "Es ist wichtig, dass wir zusammenarbeiten.",[]],
                ["Hon har sagt till mig att hon kommer.", "Sie hat mir gesagt, dass sie kommt.",[]],
                ["Jag vet att jag måste öva mer.", "Ich weiß, dass ich mehr üben muss.",[]],
                ["Har har försökt att behålla lugnet.", "Er hat versucht, ruhig zu bleiben.",["","","","","ruhig zu bleiben","ruhig zu bleiben"]],
                ["Jag har glömt att skriva till dig.", "Ich habe vergessen, dir zu schreiben.",[]],
                ["Det är svårt att förklara allt.", "Es ist schwer, alles zu erklären.",["","","schwer"]],
                ["Jag har lärt mig att lyssna bättre.", "Ich habe gelernt, besser zuzuhören.",["","","","","","zuhören"]],
                ["Han vet inte vad du pratar om.", "Er weiß nicht, wovon du sprichst.",[]],
                ["Jag har ett större hus än du.", "Ich habe ein größeres Haus als du.",[]],
                ["Jag har ingen lust att prata om det.", "Ich habe keine Lust, darüber zu sprechen.",[]],
                ["Han har förklarat för mig, varför det är viktigt.", "Er hat mir erklärt, warum es wichtig ist.",[]],
                ["Jag har försökt att förstå dig.", "Ich habe versucht, dich zu verstehen.",[]],
              ],
            ],


        }
},

methods: {
    touchstart() {
    this.timer = setTimeout(this.onlongtouch, this.touchduration);
    },
    touchend() {

    //stops short touches from firing the event
    if (this.timer)
        clearTimeout(this.timer); // clearTimeout, not cleartimeout..
    },

    onlongtouch() {
        this.startaOm(this.uppgifter);

    },

    skrivDubbelEssMedCtrl: function(index) {
        if(event.ctrlKey || event.altKey) {
          this.skrivDubbelEss(index);
        } else {
          var falt = document.getElementById('skrivfalt' + index);
          var aktPos = falt.selectionStart;
          if(event.shiftKey) {
              falt.value = falt.value.substr(0, aktPos) + 'S' + falt.value.substr(aktPos, falt.value.lenght);
          } else {
              falt.value = falt.value.substr(0, aktPos) + 's' + falt.value.substr(aktPos, falt.value.lenght);
          }

          falt.selectionStart = aktPos + 1;
          falt.selectionEnd = aktPos + 1;
        }

    },



    umlautTryckts: function(){
      this.umlaut = true;
    },

    skrivTysktY: function(index) {
      //om kontroll nedtryckt
        if(event.ctrlKey || event.altKey) {
          var falt = document.getElementById('skrivfalt' + index);
          var aktPos = falt.selectionStart;
          if(event.shiftKey) {
              falt.value = falt.value.substr(0, aktPos) + 'Ü' + falt.value.substr(aktPos, falt.value.lenght);
          } else {
              falt.value = falt.value.substr(0, aktPos) + 'ü' + falt.value.substr(aktPos, falt.value.lenght);
          }

          falt.selectionStart = aktPos + 1;
          falt.selectionEnd = aktPos + 1;
        } else {

          // om chromebook
          /*if (window.navigator.userAgent.indexOf("CrOS") != -1) {
               // inte säker om detta skall stå här
          }*/


          // om ej kontroll nedtryckt skall det ju funka som vanligt men måste kolla om prickar tryckts
          if (window.navigator.platform.indexOf("Linux")!=-1 && this.umlaut && window.navigator.userAgent.indexOf("CrOS") == -1) {
            this.umlaut = false;
            return; // skall returna om linux ty där funkar omlaut ändå

          } // obs om den är chromebook tycker den att den är linux också därför måste säkerställas att linux men EJ chromebook



          falt = document.getElementById('skrivfalt' + index);
          aktPos = falt.selectionStart;
          if(event.shiftKey) {

            if(this.umlaut) {falt.value = falt.value.substr(0, aktPos) + 'Ü' + falt.value.substr(aktPos, falt.value.lenght); this.umlaut= false;return;}
              falt.value = falt.value.substr(0, aktPos) + 'U' + falt.value.substr(aktPos, falt.value.lenght);
          } else {

            if(this.umlaut) {falt.value = falt.value.substr(0, aktPos) + 'ü' + falt.value.substr(aktPos, falt.value.lenght); this.umlaut= false;return;}
              falt.value = falt.value.substr(0, aktPos) + 'u' + falt.value.substr(aktPos, falt.value.lenght);
          }

          falt.selectionStart = aktPos + 1;
          falt.selectionEnd = aktPos + 1;
        }

    },



    skrivDubbelEss: function(index) {
        var falt = document.getElementById('skrivfalt' + index);
        var aktPos = falt.selectionStart;
        falt.value = falt.value.substr(0, aktPos) + 'ß' + falt.value.substr(aktPos, falt.value.lenght);
        falt.selectionStart = aktPos + 1;
        falt.selectionEnd = aktPos + 1;
    },
    visaFacit: function(index) {

        document.getElementById('svar' + index).classList.add("visa-svar");
        document.getElementById('oga' + index).classList.add("visa-oga");
    },
    doljFacit: function(index) {

        document.getElementById('svar' + index).classList.remove("visa-svar");
        document.getElementById('oga' + index).classList.remove("visa-oga");
    },
    fyllOvningar: function() {



        for (var i=0; i< 10; i++) {
            if (window.document.done['BlandadeOvningar']['dinRattning'][i] != "rätt") {
                var falt = document.getElementById('skrivfalt' + i);
                falt.value = window.document.done['BlandadeOvningar']['dittSvar'][i];
            }
        }

    },
    fyllFacit: function(uppgifter) {
        var that = this;
        uppgifter.forEach(function(element, index) {
            var facitfalt = document.getElementById('facitfalt' + index); //är nog vad användare skrev

            var anvandarensSvar = window.document.done['BlandadeOvningar']['dittSvar'][index]; // här måste joxas för att kunna rödmarkera under ord



            //kanske i bästa fall räcker med att lägga en till funktion här som bearbetar anvandarensSvar. Påbörjat 250308
            var svarcontainer =  document.createElement("div");

            //svarcontainer.style="display: inline"

            var svarskedja;
            if(anvandarensSvar != null) {
              svarskedja = anvandarensSvar.split(" ");
            }

            var i=0;
            if(svarskedja) {
              for(i; i<svarskedja.length; i++){
                  var ordelement = document.createElement("div");
                  ordelement.innerHTML=svarskedja[i];
                  ordelement.style="display: inline";

                  //försök kolla om aktuellt ord att ev understryka ej finns i facit

                  //if(!element[1].includes(svarskedja[i])) {
                  if(!that.finnsOrdIKedjan(svarskedja[i], element[1])){
                    ordelement.style="text-decoration: underline; text-decoration-color: red; text-decoration-style: wavy;  display: inline";
                  }

                  var tomrum =  document.createElement("div");
                  tomrum.style="display: inline";
                  tomrum.innerHTML=" ";

                  svarcontainer.appendChild(ordelement);
                  svarcontainer.appendChild(tomrum);
              }
            }



            //console.log(svarcontainer);
            facitfalt.innerHTML="";
            facitfalt.append(svarcontainer);

            // ovanstående 250308

            //facitfalt.innerHTML = anvandarensSvar  || "";  //denna var i originalet

        })

    },
    finnsOrdIKedjan: function(ord, kedja){


      var facitfält = kedja.split(" ");
      var resultat = false;
      facitfält.forEach(function(item) {
        //console.log(item);
        if(item.replace(/[.,!?]/g, '') == ord.replace(/[.,!?]/g, '')) {
          resultat = true;

        }

      });
      return resultat;

    },
    sparaKnapptryck: function(index) {

      //joxande för att få virt keyboard att funka

      var falt = document.getElementById('skrivfalt' + index);
      this.cursorX = falt.selectionStart;
      this.cursorY=index;
      // ------------------------------



      //nedan bör läggas som särskild funktion som kan åkallas såväl från riktigt knapptryck som från virtualkeyboard-tryck
        //var that = this;
        setTimeout(function(){
            var falt = document.getElementById('skrivfalt' + index);
            window.document.done['BlandadeOvningar']['dittSvar'][index] = falt.value;
        },10); //ska va 10

        //window.localStorage.done[BlandadeOvningar][index] = falt.value;

    },
    sudda: function(uppgifter) {

        //var that = this;
        var langd = uppgifter.length;
        for (var i=0; i< langd; i++) {
            if (window.document.done['BlandadeOvningar']['dinRattning'][i] != "rätt") {
                var falt = document.getElementById('skrivfalt' + i);
                window.document.done['BlandadeOvningar']['dittSvar'][i] = "";
                falt.value = "";
            }
        }
    },

        /*var that = this;
        uppgifter.forEach(function(element, index) {
            var falt = document.getElementById('skrivfalt' + index);
            window.document.done['BlandadeOvningar']['dittSvar'][index] = "";
            falt.value = "";
        });*/
    visaGrammatik: function() {
        this.$refs.fakta.classList.add("bredd");
        this.$refs.visa.style="display: none;"
        this.$refs.dolj.style="display: block;"
        this.$refs.visa.classList.remove("bokstart");
        this.$refs.dolj.classList.remove("bokstart");
    },
    doljGrammatik: function() {
        this.$refs.fakta.classList.remove("bredd");
        this.$refs.dolj.style="display: none;"
        this.$refs.visa.style="display: block;"
    },
    arraifieraOrd: function(str) {
        var res = str.split(" ");
        return res;
    },


    visaTyska: function(ord) {
        if (ord) {
        var e=window.event;
        var posX = e.clientX;
        var posY = e.clientY;
        var element = document.getElementById('fuskOrd');
        element.classList.remove("doljTyska");
        element.classList.add("visaTyska");
        element.style.top=(posY -50 + "px");
        element.style.left=(posX + "px");
        element.innerHTML = ord;
        setTimeout(function() {
            element.style.opacity="1";
        },1);

        }
    },
    doljTyska: function() {
        var element = document.getElementById('fuskOrd');
        element.classList.remove("visaTyska");
        element.classList.add("doljTyska");
        element.innerHTML = "";
        element.style.opacity="0";
    },
    sattKnappfarg: function(index, typ) {
        var rodknapp = document.getElementById('rodknapp' + index);
        var gronknapp = document.getElementById('gronknapp' + index);

        rodknapp.classList.remove("svagare");
        rodknapp.classList.remove("rod-puls");
        gronknapp.classList.remove("svagare");
        gronknapp.classList.remove("gron-puls");

        if(typ==="tom") {
            rodknapp.classList.add("rod-puls");
            gronknapp.classList.add("gron-puls");
        }
        if(typ==="gron") {
            rodknapp.classList.add("svagare");
        }
        if(typ==="rod") {
            gronknapp.classList.add("svagare");
        }
    },

    fargaKnappar: function(uppgifter) {
        this.rattningskommentarer = [];
        var that=this;
        var rattning = window.document.done['BlandadeOvningar'];
        uppgifter.forEach(function(element, index) {

            that.sattKnappfarg(index, "tom");


            //om användaren tycker rätt
            if(rattning['dinRattning'][index] !="rätt") {



            /* helt rätt är alltid rätt*/
            if (rattning['dittSvar'][index] === that.uppgifter[index][1]){
                    window.document.done['BlandadeOvningar']['dinRattning'][index]="rätt";
                    that.rattningskommentarer.push([]); //om helt rätt behövs inga kommernatarer utan tom array


                    // om fältet helt tomt gör grått

                } else if ( (!rattning['dittSvar'][index])  ){
                    window.document.done['BlandadeOvningar']['dinRattning'][index]="";
                    that.rattningskommentarer.push([]);

                    // om halvrätt - gör rött men skriv också kommentarer alt skriv inga kommentarer om helfel
                } else {

                    window.document.done['BlandadeOvningar']['dinRattning'][index]="fel";

                    //här skall vi kalla på rättningsfunktionerna
                    var rattningsfeedback = that.svarskollen(that.uppgifter[index][1], rattning['dittSvar'][index])

                    that.rattningskommentarer.push(rattningsfeedback); //om helt rätt behövs inga kommernatarer utan tom array


                }

            } else {
                that.rattningskommentarer.push([]);
            }

            //här korrigeras knappfärgerna
            if(rattning['dinRattning'][index]==="fel") {
                that.sattKnappfarg(index, "rod");
            }
            if(rattning['dinRattning'][index]==="rätt") {
                that.sattKnappfarg(index, "gron");
            }
            if(!(rattning['dinRattning'][index])) {
                that.sattKnappfarg(index, "tom");
            }

        })
    },
    grontryckt: function(index) {
        var that=this;
        var rattning = window.document.done['BlandadeOvningar']['dinRattning'][index];
        if (rattning === null || rattning === "" || rattning === "fel" ) {
            window.document.done['BlandadeOvningar']['dinRattning'][index] = "rätt"
            that.sattKnappfarg(index, "gron");

        } else {
            window.document.done['BlandadeOvningar']['dinRattning'][index] = "";
            that.sattKnappfarg(index, "tom");
        }
    },
    rodtryckt: function(index) {
        var that=this;
        var rattning = window.document.done['BlandadeOvningar']['dinRattning'][index];
        if (rattning === null || rattning === "" || rattning === "rätt") {
            window.document.done['BlandadeOvningar']['dinRattning'][index] = "fel";
            that.sattKnappfarg(index, "rod");
        } else {
            window.document.done['BlandadeOvningar']['dinRattning'][index] = "";
            that.sattKnappfarg(index, "tom");
        }
    },
    tillRattning: function() {
        var that = this
        document.getElementById('ark').classList.add("osynlig");
        document.getElementById('facit-ark').classList.remove("osynlig");
        window.scrollTo(0,0);
        this.fyllFacit(that.uppgifter);
        this.fargaKnappar(that.uppgifter);

    },
    tranaIgen: function() {
        this.allaRatt();
        document.getElementById('facit-ark').classList.add("osynlig");
        document.getElementById('ark').classList.remove("osynlig");
        this.$forceUpdate();
    },
    allaRatt: function() {
        this.fullrattad = false;
        var g=0;
        window.document.done['BlandadeOvningar']['dinRattning'].forEach((item) => {
            if (item==="rätt") {
                g++;
            }
        });

        if (g==this.uppgifter.length && g>0) {
            this.fullrattad = true;

        }
    },
    arAlltRatt: function(){ //denna är i princip som förra men används för att skriv alla rätt. förra används efteråt för att ev ej visa facit
      var status = false; // den förra kan tas bort. Och denna kan programmeras så att hittat fel eller "" ger false och inte
      var g=0;            // räkna antalet rätt ty window.document.done kan ha fler eller färre items än this.uppgifter
      window.document.done['BlandadeOvningar']['dinRattning'].forEach((item) => { // pga tidigare sparning i webbläsarminnet
          if (item==="rätt") {
              g++;
          }
      });

      if (g==this.uppgifter.length) {
          status = true;

      }
      return status;

    },
    startaOm: function(uppgifter) {
        //var that = this;
        var langd = uppgifter.length;
        for (var i=0; i< langd; i++) {
            window.document.done['BlandadeOvningar']['dinRattning'][i] = "";
            window.document.done['BlandadeOvningar']['dittSvar'][i] = "";
            this.fullrattad = false;
        }
            document.getElementById('ark').classList.add("osynlig");
            document.getElementById('ark').classList.remove("osynlig");
            this.$forceUpdate();
    },

    //för att få rättningskommentarer
    svarskollen: function(facit, svar){
      var svarsarray = [];

      //om det var HELT rätt
      if(facit == svar) {
        svarsarray.push("rätt");

        return svarsarray;
      }

      // var bara skrifläge fel returna det
      if (svar.toLowerCase() == facit.toLowerCase()) {
        svarsarray.push("stor/liten bokstav");
        return svarsarray;
      }

      // svar bara skiljetecken fel - returna det
      if (this.skippaSkiljetecken(svar) == this.skippaSkiljetecken(facit)) {
        svarsarray.push("skiljetecken");
        return svarsarray;
      }


      // var BÅDE skiljetecken OCH skriftläge fel, men bara det - returna det
      if (this.skippaSkiljetecken(svar.toLowerCase()) == this.skippaSkiljetecken(facit.toLowerCase())) {
        svarsarray.push("skiljetecken");
        svarsarray.push("stor/liten bokstav");
        return svarsarray;
      }

      //om ordföljden är fel (med rätt eller fel skriftläge och skiljetecen)
      if (this.kollaOrdföljd(facit, svar)) {
        svarsarray.push("ordföljd");
        return svarsarray;
      }


      //om artiklar är fel (med rätt eller fel skriftläge och skiljetecen)
      if (this.kollaArtiklar(facit, svar)) {
        svarsarray.push("artiklar");
        return svarsarray;
      }

        // inget enkelt fixbart fel hittades utan "helfel" och ingen kommentar skickas med

          return svarsarray;
    },
    skippaSkiljetecken: function(input) {
      var resultat = input.replace(/,/g, '');
      resultat = resultat.replace(/\./g, '');
      resultat = resultat.replace(/!/g, '');
      resultat = resultat.replace(/\?/g, '');
      return resultat
    },
    kollaOrdföljd: function(facit, svar) {
      var trimmatFacit = this.skippaSkiljetecken(facit.toLowerCase());
      var trimmatSvar = this.skippaSkiljetecken(svar.toLowerCase());
      var facitFält = trimmatFacit.split(" ");
      var svarFält = trimmatSvar.split(" ");

      var resultat = true;
      svarFält.forEach((item) => {
        if(!facitFält.includes(item)) {
          resultat = false;
        }
      });

      if(facitFält.length != svarFält.length){
        resultat = false;
      }
      return resultat;
   },
   kollaArtiklar: function(facit, svar) {

      var trimmatFacit = this.skippaSkiljetecken(facit.toLowerCase());
      var trimmatSvar = this.skippaSkiljetecken(svar.toLowerCase());
      var facitFält = trimmatFacit.split(" ");
      var svarFält = trimmatSvar.split(" ");



      if(facitFält.length !=svarFält.length) {

        return false;  //fel antal ord från början ingen idé kolla
      }

      var artikelfält = ["der", "die", "das", "den", "dem", "des", "einen", "ein", "eine", "einer"];
    // ta bort alla artiklar
      for (var i = facitFält.length; i>=0; i--){
        if (artikelfält.includes(facitFält[i])) {
          facitFält.splice(i,1);
        }
        if (artikelfält.includes(svarFält[i])) {
          svarFält.splice(i,1);
        }
      }


      if(facitFält.length !=svarFält.length) {
        return false;  // nåt var artikel och helt annat ord i annan mening - ingen ide
      }


      var resultat = true;

      for (i = 0; i<facitFält.length; i++){
        if(facitFält[i]!=svarFält[i]) {
          resultat = false;
        }
      }
      return resultat;
   },

   //metod för att skriva tecken från virtuellt keyboard
   type(character) {

     var falt = document.getElementById('skrivfalt' + this.cursorY);
     if(falt==null) return;
     var aktPos = falt.selectionStart;
     falt.value = falt.value.substr(0, aktPos) + character + falt.value.substr(aktPos, falt.value.lenght);
     falt.selectionStart = aktPos + 1;
     falt.selectionEnd = aktPos + 1;


     falt.focus();


     var that = this;
     setTimeout(function(){
         window.document.done['BlandadeOvningar']['dittSvar'][that.cursorY] = falt.value;
     },10); //ska va 10
   },

   setFocus(index){
     this.cursorY = index;
     var falt = document.getElementById('skrivfalt' + index);
     this.cursorX = falt.selectionStart;
   },

   genereraOvningar(steg){ // lägg in meningarna i this.Blandadeovningar.genererade (eller vad det var)
     var sammaSteg = false;
     if(this.steg == steg) sammaSteg = true;
     this.steg = steg;
     this.fullrattad = false;
     window.document.done['GenereradeMeningar']['dinRattning'][0] = steg;
     var max=this.uppgiftsbas[steg-1].length;
     var slumpordning = [];
     var slump = -1;
     for(var i=0; i<10; i++) {
       do {
         slump = Math.floor(Math.random() * max);
       } while(slumpordning.includes(slump));
       slumpordning[i]=slump;
       this.uppgifter[i]=this.uppgiftsbas[steg-1][slump];
       window.document.done['GenereradeMeningar']['dittSvar'][i]= this.uppgifter[i];
       window.document.done['BlandadeOvningar']['dittSvar'][i]= "";
       window.document.done['BlandadeOvningar']['dinRattning'][i]= "";
     }

     document.getElementById('facit-ark').classList.add("osynlig");
     document.getElementById('ark').classList.remove("osynlig");



    if(sammaSteg) this.startaOm(this.uppgifter);


   }


//value


},
mounted() {
    this.allaRatt();
          if(this.uppgifter.length>0) {

            var that=this;


            setTimeout(function() {
              that.fyllOvningar(that.uppgifter);
            }, 30);


          }





        window.scrollTo(0, 0);


    },
updated() {
    document.title = "Blandade övningar steg "+this.steg+" | Tysk grammatik";
    this.fyllOvningar(this.uppgifter);
        window.scrollTo(0, 0);
        this.$refs.ytterclass.style.display="none";
        var that = this;
        setTimeout(function() {
            that.$refs.ytterclass.style.display="block";
        }, 30);

    },


}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>


/*fram och tillbaka tekniker för inskjutet grammatikblad*/
.dolj {
    display: none;
}


@keyframes bokblink {
  0% {color: black}
  45% {color: black}
  50% {color: grey}
  55% {color: black}
  100% {color: black}
}

.inlajn2 {
    display: inline;
}

.bok-container {

    /*position: sticky;*/
    top: 0;
    float: left;
    position: relative;
    z-index:10;
}

.bok {
    position: absolute;

    padding-left: 0.5em;

    top: 2px;
    z-index:15;

    background: rgba(255,255,255,0.7);
    border: solid 1px;
    border-left: none;
    padding-top:4px;
    padding-bottom:4px;
    padding-right: 3px;

    border-radius: 0 3px 3px 0;

    color: black;



}

.bokflik {

}

.visa {

}
.dolj {
    /*z-index:-1;*/
    /*top: 5em;*/
}


.bok:hover {
    color: #2c3e50;
    transition: 0.5s;
}

/*innan man nånsin tryck på knappen finns denna sen tas den bort*/
.bokstart {
    -webkit-animation: mjukframkomst 2s; /* Safari 4.0 - 8.0 */
    /*-webkit-animation-delay: 2s;*/
    animation: mjukframkomst 2s;
    /*animation-delay: 2s;*/

    animation-name: bokblink;
    animation-duration: 10s;
    animation-iteration-count: infinite;
}

/* Safari 4.0 - 8.0 */
@-webkit-keyframes mjukframkomst {
  0% {
      opacity: 0;
  }
  50% {
      opacity: 0;
  }
  100% {
      opacity: 1;
  }
}

/* Standard syntax */
@keyframes mjukframkomst {
    0% {
        opacity: 0;
    }
    50% {
        opacity: 0;
    }
    100% {
        opacity: 1;
    }

}



.arrow {
    margin-top:0.5em;
    border-color: #2c3e50;
}
/*slut med grammatikbladtekniker*/



.ark-container {
    /*vertical-align: top;*/
    display: inline;
    position: relative;
    z-index:1;
}



.ark-container-facit {
    /*vertical-align: top;*/
    display: inline;
    position: relative;
    z-index:2;
}



.ark {
    position:relative;/*Ta bort om det fuckar sig!!!*/
    /*vertical-align: top;*/

    /*width: 800px;*/
    width: calc(100vw - 463px);
    background-color: #eeffee;
    /*background-image: linear-gradient(to bottom right, white, #ffffe0);*/
    /*margin: auto;*/
    padding: 0em 0 1em 0;


    box-shadow: 0 19px 38px rgba(0,0,0,0.30), 0 15px 12px rgba(0,0,0,0.22);
    color: black;
    margin-bottom: 1em;
    display: inline-block;
    z-index:1;
}


.ark-facit {
    position:relative;/*Ta bort om det fuckar sig!!!*/
    width: calc(100vw - 463px);
    background-color: #fee;
    /*background-color: #ebe7eb;*/
    padding: 0em 0 1em 0;


    box-shadow: 0 19px 38px rgba(0,0,0,0.30), 0 15px 12px rgba(0,0,0,0.22);
    color: black;
    margin-bottom: 1em;
    display: inline-block;
    z-index:2;

    /*display: block;*/
    -webkit-animation: mymove 1s; /* Safari 4.0 - 8.0 */
    animation: mymove 1s;



}


.osynlig {
    display: none;
}


#genmen{ /*se till att göra responsive som ark*/
  background-color:#eeffee;
  margin-bottom: 1em;
  width: calc(100vw - 463px);
  display: inline-block;
  padding-top: 1em;
  padding-bottom: 1em;
}

.genknapp {
  background-color: white;
  padding: 0.5em;
  margin: 1em;
  border-style: solid;
  border-width: 1px;
  border-color:black;
}
.genknapp:hover {
  background-color: lightgrey;
  cursor: context-menu;
}




@media (max-width: 1024px/*480px*/) {
    .ark {
        width: 100%;
    }

    .ark-facit {
        width: 100%;
    }

    #genmen {
      width: 100%;
    }

    .inlajn2 {
      display:block;
    }
    .ytterclass {
        display: inline-block;
    }

    .keyboardsynlighet {

      display: none !important;

      background-color:red;
    }
}


/* Safari 4.0 - 8.0 */
@-webkit-keyframes mymove {
  from {
      margin-top: 800px;
  }
  to {
      margin-top:0px;
  }
}

/* Standard syntax */
@keyframes mymove {
    from {
        margin-top: 800px;
    }
    to {
        margin-top:0px;
    }
}



/* Safari 4.0 - 8.0 */
@-webkit-keyframes mymove2 {
  from {
      top: 0px;
  }
  to {
      top:-200px;
  }
}

/* Standard syntax */
@keyframes mymove2 {
    from {
        top: 0;
    }
    to {
        top:-200px;
    }
}







.uppgift {
    margin: 2em 1em 1em 1em;
    text-align: left;
}

.skrivfalt {
    margin-top: 0.5em;
    width: 100%;
    height: 2em;
    border-color: #b3b8bb;
    border-style: none none solid none;
    font-family: 'Kalam', serif;
    font-size: 1.5em;
    /*color: #008;*/
    background-color: rgba(255, 255, 255, 0);
}

@media (max-width: 1024px) {
    .skrivfalt {
        min-height: 1em;
        height: 100%;
    }

}

.skrivfalt-facit {
    min-height: 1em;
    height: 100%;
    margin-top: 0.5em;
    width: 100%;

    border-color: #b3b8bb;
    border-style: none none solid none;
    font-family: 'Kalam', serif;
    font-size: 1.5em;
    /*color: #008;*/
    background-color: rgba(255, 255, 255, 0);
}








input:focus {
    outline: none;
}

.fraga {
    font-family: "Times New Roman", Times, serif;
    font-size: 1.3em;

}

.svar {
    width:95%;
    display: inline-block;
}
.svar-text {
    visibility:hidden;
    opacity: 0;
    transition: visibility 0s, opacity 0.5s linear;
    /*display: none*/
    color: #00A;
}

.facit-text {
    color: #00A;
}

.smalare-border {
    border-width: 2px;
}

.visa-svar {
    visibility: visible;
    opacity: 1;
}

.visa-oga {
    color: black !important;
}

.facitomrade {

    width: 100%;

}
.oga {
    color: #b3b8bb;
    width:5%;
    display:inline-block;
    text-align: right;
    font-size: 1.3em;
}
h3 {
    /*padding-top: 0.5em;*/
    font-family: serif;
    /*font-size: 1.5em;*/
    font-size: 2em;

}

@media (max-width:400px) {
    h3 {
        font-size:1.5em;
    }
}
.eraser {
    text-align: left;
    padding-left: 1em;
    color: #b3b8bb;
    display: block;
    font-size: 150%;
    margin-bottom: -20px;
}

.eraser-button {

    display: inline;
}

.restart-button {
    display: inline;
    float:right;
    padding-right: 10px;
}

.eraser-button:hover {
    color: red;
}

.restart-button:hover {
    color: red;
}


.ytterclass {

    display: block;
    -webkit-animation: mymove 1s; /* Safari 4.0 - 8.0 */
    animation: mymove 1s;
    /*position: relative;
    z-index:1;*/
}

.nav-rad {
    width: 100%;
    position: relative;
    padding-top: 1em;
    padding-bottom: 2em;
}
.foregaende {
    margin-left: 1em;
    position: absolute;
    left: 0;

}
.nasta {
    margin-right: 1em;
    position: absolute;
    right: 0;
}

.steg-nav {
    text-decoration: none;
    color: grey;
}

.steg-nav:hover{
    text-decoration: underline;
}

@media (max-width:470px) {
    .steg-nav {
        display: none;
    }
}

.fragerad {
    display: inline;
}

.doljTyska{
   display: none;
}
.visaTyska {
    /*opacity: 1;*/
}

#fuskOrd {
    opacity:0;
    position: fixed;
    padding:5px;
    border-radius: 5px;
    border-style: solid;
    border-width: 1px;
    background-color: #eef;
    transition: opacity 0.75s;
}

.pekare {
    cursor: pointer;
}


.gra-text {
    /*margin-top: 1em;*/
    color: grey;
}

.rodknapp {
    background-color: #ff9999;
    color: #ff3333;
    margin-right: 20px;
}
.rodknapp:hover {
    border-color: black;
}

.gronknapp:hover {
    border-color: black;
}


.gronknapp {
    background-color: #99ff99;
    color: #11dd11;
}
.rattningsknappar {
    float: right;
}

.knapp {
    text-align: center;
    padding-top: 5px;
    border-radius: 3px;
    border: solid 1px;
    display: inline-block;
    width: 60px;
    height: 22px;
}

.svagare {
    filter: grayscale(100%);
}


.rod-puls {
/*    -webkit-animation: pulsera1 1s ease-out;
    -webkit-animation-iteration-count: infinite;*/
    filter: grayscale(100%);
}
@-webkit-keyframes pulsera1 {
    0% {
        filter: grayscale(100%);
    }
    50% {
        filter: grayscale(0%);
    }
    100% {
        filter: grayscale(100%);
    }
}

.gron-puls {
/*    -webkit-animation: pulsera2 1s ease-out;
    -webkit-animation-iteration-count: infinite;*/
    filter: grayscale(100%);
}
@-webkit-keyframes pulsera2 {
    0% {
        filter: grayscale(0%);
    }
    50% {
        filter: grayscale(100%);
    }
    100% {
        filter: grayscale(0%);
    }
}


.vit-puls {
  animation-name: pulsera3;
    animation-duration: 4s;
    animation-iteration-count: infinite;
}
@-webkit-keyframes pulsera3 {
    0% {
        filter: opacity(100%);
    }
    25% {
        filter: opacity(100%);
    }
    80% {
        filter: opacity(100%);
    }
    90% {
        filter: opacity(0%);
    }
    100% {
        filter: opacity(100%);
    }
}


#tillRattning {
    display: inline-block;
    border: solid 1px;
    /*border-radius: 3px;*/
    padding:6px;
    background-color: #fcc;
    /*background-color: #ebe7eb;*/
    /*font-family: 'Rochester', cursive;*/
    font-family: 'Marck Script', cursive;
    font-size: 2em;
    -webkit-box-shadow: 0 10px 6px -6px #777;
       -moz-box-shadow: 0 10px 6px -6px #777;
            box-shadow: 0 10px 6px -6px #777;
}

#tillRattning:hover {
    background-color: #fbb;

}

#tranaIgen {
    display: inline-block;
    border: solid 1px;
    padding:3px;
    background-color: #fff;
    font-family: 'Marck Script', cursive;
    font-size: 2em;
    -webkit-box-shadow: 0 10px 6px -6px #777;
       -moz-box-shadow: 0 10px 6px -6px #777;
            box-shadow: 0 10px 6px -6px #777;

}

#tranaIgen:hover {
    background-color: #eee;
}

#allaRätt {
  display: block;
  color: green;
  padding:3px;

  font-family: 'Marck Script', cursive;
  font-size: 2em;


}
.facit-uppgift {
    padding-bottom: 35px;
    border: solid 1px;
    padding-left: 5px;
    padding-right: 5px;
}

.kommentarer {
    color:#ff3333;
}

.underkrull {
  text-decoration: underline;
  text-decoration-color: red;
  text-decoration-style: wavy;
}


.keyboardsynlighet {
  display:inline;
}


#keyboard{

  color: #b3b8bb;
  position: sticky;
  top: 70px;
  background-color:white;
  padding: 5px;

  border: 2px solid #b3b8bb;
  width: 50px;


  left: calc(100vw - 300px);

}

.keyboardletter:hover {
  color: black;
  öööcursor: context-menu;
  cursor: default;
}




</style>
